const TasksBrowseRouteNavigationOptions = {
  title: 'Tasks',
  headerTitle: () => null,
  headerBackVisible: false,
};

export default TasksBrowseRouteNavigationOptions;
